<template>
  <div v-if="cleaningFees.length > 0">
    <h2>{{ t('addedCleaningFees') }}</h2>
    <div class="mt-4 space-y-2">
      <div
        v-for="(fee, index) in cleaningFees"
        :key="index"
        :class="card({ class: 'flex-row p-4' })"
      >
        <div class="flex-1">
          <p class="font-medium">{{ fee.description }}</p>
          <p v-if="fee.photoFileKeys?.length" class="mt-1 text-sm text-gray-600">
            {{ fee.photoFileKeys.length }} {{ t('photosAttached') }}
          </p>
        </div>
        <div class="text-right">
          <p v-currency="fee.price" class="font-semibold" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { VehicleExtraType } from '@carvia/ros-client-types';
import { card } from '@carvia/theme/lib/cva/card';
import type { Booking } from '@/entities/bookings/booking.entity.ts';
import { getCustomBookedExtras } from '@/utils/pricing.utils';

const { t } = useI18n();

interface Props {
  booking: Booking;
}

const props = defineProps<Props>();

const cleaningFees = computed(() =>
  getCustomBookedExtras(props.booking.priceCalculation).filter(
    (extra) => extra.customVehicleExtraType === VehicleExtraType.CLEANING_FEE,
  ),
);
</script>

<i18n lang="json">
{
  "en": {
    "addedCleaningFees": "Cleaning Fees",
    "photosAttached": "photo(s) attached"
  },
  "de": {
    "addedCleaningFees": "Reinigungsgebühren",
    "photosAttached": "Foto(s) beigefügt"
  },
  "es": {
    "addedCleaningFees": "Tasas de limpieza",
    "photosAttached": "foto(s) adjunta(s)"
  }
}
</i18n>
